export const getStandAloneElement = () => document.querySelector('#standalone-selfservice-root');
